import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Box, FlexBox } from '@sternum/styled-system';
import { Popup, Text14 } from '@sternum/ui';
import { Text } from '@sternum/web/components';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ContainerFull = styled(FlexBox)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const ContainerSmall = styled(FlexBox)`
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
`;

export const PopupStyled = styled(Popup)`
  background: ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
  color: ${ct({ Dark: Colors.Light, Light: Colors.Light })};
  width: 280px;
`;

export const PopupContentsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  margin: 0;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
`;

export const MenuItem = styled.div<{ $active?: boolean; $smallSpacing?: boolean }>`
  width: 100%;
  padding: ${(props) => (props.$smallSpacing ? '8px' : '12px')} 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  transition: background 0.2s;

  &:hover {
    background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
    cursor: pointer;
  }

  ${(props) =>
    props.$active &&
    css`
      background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
    `}
`;

export const LinkStyled = styled(Link)`
  width: 100%;
  color: ${ct({ Dark: Colors.Light, Light: Colors.Light })};
  text-decoration: none;

  &[aria-disabled] {
    cursor: inherit;
  }
`;

export const MenuDivider = styled.div`
  display: flex;
  align-self: center;
  width: 90%;
  height: 1px;
  background: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
  margin: 8px 0;
`;

export const AvatarText = styled(Text)`
  font-size: 12px;
  font-weight: 700;
`;

export const FullNameText = styled(Text14)`
  color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;

export const ClientNameText = styled(Text)`
  max-width: 75px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 500;
`;

export const StatusText = styled(Text)`
  font-size: 12px;
  color: ${ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
`;

export const StatusDot = styled(Box)<{ $status: 'active' | 'inactive' }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${ct({ Dark: Colors.GreenMiddle, Light: Colors.GreenMiddle })};
`;
